var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"users-list users-list-admins"},[_c('list-users',{attrs:{"users":_vm.allAdmins,"type":"admins"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }